import React from "react";
import { Link } from "@mui/material";
import { LARAVEL_API_PATH } from "../../../constants/path";
import { useAvailableConsentTypes } from "../../../hooks/useAvailableConsentTypes";

const DataProcessingConsentLink: React.FC = () => {
    const { isTypeAvailable } = useAvailableConsentTypes();

    if (!isTypeAvailable('data_processing_consent')) {
        return null;
    }

    return (
        <Link
            className={'footer__link'}
            href={`${LARAVEL_API_PATH}consent-download/data_processing_consent`}
            target="_blank"
        >
            Согласие на обработку персональных данных
        </Link>
    );
};

export default DataProcessingConsentLink;

